export default __webpack_public_path__ + "static/media/L12.e9b453e6.jpg";